import { palette } from '../color/palette';
import { palettenext } from '../color/palette-next';

export const tokens = {
  typography: {
    fontFamily: '"Inq", sans-serif',
    fontWeight: {
      regular: '500',
      demibold: '600',
      bold: '700',
    },
    heading: {
      '1': {
        fontSize: '40px',
        lineHeight: '52px',
      },
      '2': {
        fontSize: '36px',
        lineHeight: '44px',
      },
      '3': {
        fontSize: '32px',
        lineHeight: '40px',
      },
      '4': {
        fontSize: '28px',
        lineHeight: '36px',
      },
      '5': {
        fontSize: '24px',
        lineHeight: '32px',
      },
      '6': {
        fontSize: '20px',
        lineHeight: '28px',
      },
    },
    text: {
      xsmall: {
        fontSize: '12px',
        lineHeight: '20px',
      },
      small: {
        fontSize: '14px',
        lineHeight: '20px',
      },
      medium: {
        fontSize: '16px',
        lineHeight: '24px',
      },
      large: {
        fontSize: '18px',
        lineHeight: '28px',
      },
    },
  },
  /* 
        PLEASE NOTE:
        
        These space tokens are a work in progress and are subject to revision.
        Please use them with caution!
    */
  space: {
    none: '0px',
    xxsmall: '0.25rem',
    xsmall: '0.5rem',
    small: '0.75rem',
    medium: '1rem',
    large: '2rem',
    xlarge: '3rem',
    xxlarge: '6rem',
  },
  border: {
    radius: {
      small: '2px',
      standard: '4px',
      large: '8px',
      xlarge: '12px',
      xxlarge: '16px',
    },
    width: {
      standard: '1px',
      large: '2px',
    },
    color: {
      neutral: palette.neutral[20],
    },
  },
  shadows: {
    medium: '0px 5px 15px 0px rgba(0, 0, 0, 0.05)',
    dark: '0px 4px 15px 0px #161D2526',
  },
  /* 
        PLEASE NOTE:

        These color tokens are a work in progress and are subject to revision.
        Please use them with caution!
    */
  color: {
    foreground: {
      brandAccent: palette.brand[100],
      brandAccentLight: palette.brand[40],
      caution: palette.yellow[100],
      cautionLight: palette.yellow[10],
      critical: palette.red[100],
      criticalLight: palette.red[10],
      info: palette.blue[100],
      infoLight: palette.blue[10],
      link: palette.blue[100],
      linkLight: palette.blue[40],
      linkHover: palette.blue[70],
      neutral: palette.neutral[90],
      neutralInverted: palette.neutral[3],
      positive: palette.green[100],
      positiveLight: palette.green[10],
      primary: palette.black,
      primaryInverted: palette.white,
      secondary: palettenext.neutral[800],
      tertiary: palettenext.neutral[500],
      secondaryInverted: palette.neutral[20],
      success: palette.green[100],
    },
    background: {
      body: palette.white,
      // TODO - lift this out of the background tokens
      edit: palette.neutral[3], // the color of the background when editing a card
      neutral: palette.neutral[90],
      neutralHover: palette.neutral[70],
      neutralActive: palette.neutral[80],
      /* Brand tones */
      brandAccent: palette.brand[100],
      brandLight: palette.brand[50],
      /* Semantic tones */
      caution: palette.yellow[100],
      cautionLight: palettenext.yellow[50],
      cautionHover: palette.yellow[40],
      cautionActive: palette.yellow[70],
      critical: palette.red[100],
      criticalLight: palettenext.red[50],
      criticalHover: palette.red[40],
      criticalActive: palette.red[70],
      info: palette.blue[100],
      infoLight: palettenext.blue[50],
      infoHover: palette.blue[40],
      infoActive: palette.blue[70],
      positive: palette.green[100],
      positiveLight: palettenext.green[50],
      positiveHover: palette.green[40],
      positiveActive: palette.green[70],
    },
    border: {
      focus: palette.black,
    },
  },
};
